<div class="bg-color-white mat-elevation-z1" fxLayout.gt-sm="row">
  <div
    class="u-padding-16"
    fxFlex.gt-sm="300px"
    fxShow="false"
    fxShow.gt-sm="true"
  >
    <mat-nav-list>
      <a
        *ngFor="let membership of profile.groups | appVisibleGroups"
        [queryParams]="{ group: membership.document.slug }"
        [routerLink]="['.']"
        [routerLinkActive]="['is-active']"
        [routerLinkActiveOptions]="{ exact: true }"
        class="u-display-block"
        queryParamsHandling="merge"
      >
        <mat-list-item [ngStyle]="{ 'font-size': '14px' }">
          {{ membership.document.name }}
        </mat-list-item>
      </a>
    </mat-nav-list>
  </div>
  <div
    class="u-borderLeft-grey100 u-padding-0-24 u-paddingBottom-24 u-paddingTop-16"
    fxFlex.gt-sm="calc(100% - 300px)"
  >
    <div *ngIf="route.snapshot.queryParamMap.get('group')">
      <ng-container
        *ngIf="
          getGroup({
            profile,
            groupSlug: route.snapshot.queryParamMap.get('group'),
          }) as membership
        "
      >
        <div class="u-marginBottom-16">
          <a [routerLink]="['/hub', membership.document.slug]"
            ><h6>{{ membership.document.name }}</h6></a
          >
        </div>
        <div class="u-padding-16-0 u-borderTop-grey100">
          <div>
            <div
              class="u-marginBottom-16"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
              >
                <p class="color-grey text-subtitle-2" i18n="@@global.segments">
                  Segments
                </p>
              </div>
              <ng-container
                *ngTemplateOutlet="
                  editButtonTemplate;
                  context: { membership: membership }
                "
              ></ng-container>
            </div>
            <div fxLayout="row" fxLayoutGap="8px">
              <p
                i18n="@@global.role"
                [ngStyle]="{ 'max-width': '48%' }"
                class="color-grey-300 u-wordWrap-breakWord u-textTruncate"
              >
                Role
              </p>
              <p
                [ngStyle]="{ 'max-width': '48%' }"
                class="u-wordWrap-breakWord u-textTruncate"
              >
                {{ membership.role | translationLookup: ['@@groupRole'] }}
              </p>
            </div>
            <div
              *ngFor="let segment of membership.document.custom_segments"
              class="u-paddingTop-8"
              fxLayout="row"
              fxLayoutGap="8px"
            >
              <p
                [ngStyle]="{ 'max-width': '48%' }"
                class="color-grey-300 u-wordWrap-breakWord u-textTruncate"
              >
                {{
                  segment.title
                    | translationLookup: ['@@groupCustomSegmentTitle']
                }}
              </p>
              <p
                [ngStyle]="{ 'max-width': '60%' }"
                class="u-wordWrap-breakWord"
              >
                <app-text-list
                  *ngIf="
                    getSelection(membership.segment_selections, segment)
                      ?.multiselected_nodes?.length
                  "
                  [list]="
                    getSelection(membership.segment_selections, segment)
                      .multiselected_nodes
                      | translationLookupList: ['@@groupCustomSegmentOption']
                  "
                  class="u-display-block color-grey"
                >
                </app-text-list>
              </p>
              <p
                *ngIf="
                  getSelection(membership.segment_selections, segment)?.node
                "
                [ngStyle]="{ maxWidth: '50%' }"
                class="u-textTruncate"
              >
                {{
                  getSelection(membership.segment_selections, segment)?.node
                    | translationLookup: ['@@groupCustomSegmentOption']
                }}
              </p>
              <i
                *ngIf="
                  !getSelection(membership.segment_selections, segment)?.node &&
                  !getSelection(membership.segment_selections, segment)
                    ?.multiselected_nodes
                "
                i18n="@@profileView.hubs.notSpecified.label"
                class="color-grey-300"
              >
                Not specified
              </i>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            canDisplayPrivateSegments({
              user,
              account: profile,
              group: membership.document,
            })
          "
          class="u-padding-16-0 u-borderTop-grey100"
        >
          <app-private-segments-selections
            [account]="profile"
            [membership]="membership"
            [user]="user"
            class="u-display-block"
          ></app-private-segments-selections>
        </div>
        <div class="u-padding-16-0 u-borderTop-grey100">
          <div *ngIf="!showLegacyGoals(membership)">
            <div
              class="u-marginBottom-16"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
              >
                <p
                  class="color-grey text-subtitle-2"
                  i18n="@@profileView.hubs.goals.title"
                >
                  Goals
                </p>
                <p
                  *ngIf="membership.goals?.length"
                  class="text-caption color-grey-300"
                >
                  {{ membership.goals?.length }}
                </p>
              </div>
              @if (
                isUser ||
                user.isAdmin ||
                ((user | appIsAdminOfGroup: membership.document) &&
                  membership.goals?.length)
              ) {
                <a
                  i18n="@@global.edit"
                  [queryParams]="{
                    groupId: membership.document._id,
                  }"
                  [routerLink]="'/update-goals'"
                  class="c-button color-blue u-textDecoration-underline--hover"
                >
                  Edit
                </a>
              }
            </div>
            <ng-container
              *ngIf="
                !membership.goals?.length &&
                !membership.seeking?.length &&
                !membership.offerings?.length
              "
            >
              <div
                *ngIf="isUser"
                class="bg-color-white u-padding-24 u-border-grey100 u-borderRadius--4px"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="row" fxLayoutAlign="start center">
                  <img
                    alt=""
                    height="64"
                    src="//storage.googleapis.com/ttc-static-images/goal-setting/Empy-state.11FF161.png"
                    width="64"
                  />
                  <div class="u-marginLeft-16">
                    <p
                      class="text-subtitle-2"
                      i18n="@@profileMoreInfo.goals.emptyStateTitle"
                    >
                      Write your first goal ✨
                    </p>
                    <p
                      i18n="@@profileMoreInfo.goals.emptyStateDescription"
                      class="color-grey-300 text-caption"
                    >
                      Goals help 10KC introduce you to the right people.
                    </p>
                  </div>
                </div>
                <button
                  i18n="@@profileMoreInfo.goals.addCta"
                  [queryParams]="{ groupId: membership.document._id }"
                  [routerLink]="'/update-goals'"
                  color="primary"
                  mat-raised-button
                >
                  Add goal
                </button>
              </div>
              <i
                *ngIf="!isUser"
                class="color-grey-300"
                i18n="@@profileView.hubs.notSpecified.label"
              >
                Not specified
              </i>
            </ng-container>
            <div *ngIf="membership.goals?.length">
              <ng-container
                *ngFor="let goal of membership.goals; let goalIndex = index"
              >
                <ng-container *ngIf="getGoalPanelData(goal) as goal">
                  <app-group-set-development-goal
                    [goal]="goal"
                    [goalIndex]="goalIndex"
                    [group]="membership.document"
                    [isEditable]="false"
                    [user]="user"
                    class="u-display-block u-marginBottom-16"
                  ></app-group-set-development-goal>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div *ngIf="showLegacyGoals(membership)" class="u-marginBottom-16">
            <div
              class="u-marginBottom-16"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <p
                i18n="@@profileView.hubs.goals.title"
                class="color-grey text-subtitle-2"
              >
                Goals
              </p>
              <ng-container
                *ngTemplateOutlet="
                  editButtonTemplate;
                  context: { membership: membership }
                "
              ></ng-container>
            </div>
            <div class="u-marginBottom-16" fxLayout.gt-xs="row">
              <div
                class="u-paddingRight-16"
                fxFlex.gt-xs="50%"
                ngClass.lt-sm="u-marginBottom-16"
              >
                <div
                  class="u-marginBottom-8"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px"
                >
                  <p i18n="@@global.want" class="text-caption color-grey-300">
                    Want
                  </p>
                  <p
                    *ngIf="membership.seeking?.length"
                    class="text-caption color-grey-300"
                  >
                    {{ membership.seeking?.length }}
                  </p>
                </div>
                <app-text-list
                  *ngIf="membership.seeking?.length"
                  [list]="
                    membership.seeking
                      | translationLookupList: ['@@groupOffering']
                  "
                  class="u-display-block color-grey"
                >
                </app-text-list>
                <i
                  *ngIf="!membership.seeking?.length"
                  i18n="@@profileView.hubs.notSpecified.label"
                  class="color-grey-300"
                >
                  Not specified
                </i>
              </div>
              <div class="u-paddingRight-16" fxFlex.gt-xs="50%">
                <div
                  class="u-marginBottom-8"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px"
                >
                  <p i18n="@@global.offer" class="text-caption color-grey-300">
                    Offer
                  </p>
                  <p
                    *ngIf="membership.offerings?.length"
                    class="text-caption color-grey-300"
                  >
                    {{ membership.offerings?.length }}
                  </p>
                </div>
                <app-text-list
                  *ngIf="membership.offerings?.length"
                  [list]="
                    membership.offerings
                      | translationLookupList: ['@@groupOffering']
                  "
                  class="u-display-block color-grey"
                >
                </app-text-list>
                <i
                  *ngIf="!membership.offerings?.length"
                  i18n="@@profileView.hubs.notSpecified.label"
                  class="color-grey-300"
                >
                  Not specified
                </i>
              </div>
            </div>
          </div>
        </div>
        <div class="u-padding-16-0 u-borderTop-grey100">
          <div
            class="u-marginBottom-16"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="8px"
          >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <p
                i18n="@@profileView.hubs.interests.title"
                class="color-grey text-subtitle-2"
              >
                Interests
              </p>
              <p
                *ngIf="membership?.industries?.length"
                class="text-caption color-grey-300"
              >
                {{ membership?.industries?.length }}
              </p>
            </div>
            <ng-container
              *ngTemplateOutlet="
                editButtonTemplate;
                context: { membership: membership }
              "
            ></ng-container>
          </div>
          <app-text-list
            *ngIf="membership.industries?.length"
            [list]="
              membership.industries | translationLookupList: ['@@groupIndustry']
            "
            class="u-display-block color-grey"
          >
          </app-text-list>
          <i
            *ngIf="!membership.industries?.length"
            i18n="@@profileView.hubs.notSpecified.label"
            class="color-grey-300"
          >
            Not specified
          </i>
        </div>
        <div
          *ngIf="
            isUser ||
            user.isAdmin ||
            (user | appIsAdminOfGroup: membership.document)
          "
          class="u-padding-16-0 u-borderTop-grey100"
        >
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <p
              i18n="@@global.interactions"
              class="color-grey text-subtitle-2 u-marginBottom-8"
            >
              Interactions
            </p>
            <ng-container
              *ngTemplateOutlet="
                editButtonTemplate;
                context: { membership: membership }
              "
            ></ng-container>
          </div>
          <ng-container *ngFor="let interaction of interactions">
            <div
              *ngIf="
                'opted_into_matchmaking' !== interaction.fieldName ||
                membership.document?.features_enabled?.introductions
              "
              class="u-marginBottom-8"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="8px"
            >
              <ng-container [ngSwitch]="membership[interaction.fieldName]">
                <mat-icon *ngSwitchCase="true" class="color-teal-700">
                  check_circle
                </mat-icon>
                <mat-icon *ngSwitchCase="false" class="color-grey-300">
                  cancel
                </mat-icon>
              </ng-container>
              <span
                i18n="@@profileView.hubs.interactions.content"
                >{interaction.text, select, other {{{ interaction.text }}}
              }</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #editButtonTemplate let-membership="membership">
  @if (
    isUser || user.isAdmin || (user | appIsAdminOfGroup: membership.document)
  ) {
    <button
      i18n="@@global.edit"
      (click)="openDialog(membership)"
      class="c-button color-blue u-textDecoration-underline--hover"
    >
      Edit
    </button>
  }
</ng-template>
